import React, { memo, useRef } from 'react';
import { Button, Collapsible, CollapsibleContent } from '@kuda/ui';
import { CodeIcon, FileArrowUpIcon, CloudArrowUpIcon } from '@kuda/ui/icons';
import CodeEditor from '../monacoEditor';

const SecretEditor = memo(({
  openCreate,
  openUpload,
  selectedFile,
  jsonInput,
  fileContent,
  onCreateClick,
  onUploadClick,
  onFileChange,
  onCodeChange,
  onCreateSecret,
  onCancel,
}) => {
  const fileInputRef = useRef(null);

  return (
    <div className="w-full flex flex-col items-center my-3">
      <div className="flex flex-row gap-4">
        <Button
          disabled={openCreate || openUpload || selectedFile}
          variant="outlined"
          onClick={onCreateClick}
        >
          <CodeIcon className="size-4" /> Input values
        </Button>
        <Button
          disabled={openCreate || openUpload || selectedFile}
          variant="outlined"
          onClick={onUploadClick}
        >
          <FileArrowUpIcon className="size-4" /> Upload file
        </Button>
      </div>

      <Collapsible open={openUpload}>
        <CollapsibleContent>
          <div
            className="flex flex-col items-center justify-center rounded-lg border border-color-border-secondary bg-color-bg-surface m-1"
            style={{ width: "50rem", height: "39rem" }}
          >
            <div
              className="flex items-center justify-center rounded-lg border border-color-border-secondary bg-color-bg-secondary my-2 p-1"
              style={{ width: "80%", height: "60%" }}
            >
              <Button variant="filled" size="lg" onClick={() => fileInputRef.current?.click()}>
                <CloudArrowUpIcon className="size-4" /> Click to upload file
              </Button>
              <input
                ref={fileInputRef}
                type="file"
                accept=".json"
                onChange={onFileChange}
                className="sr-only"
              />
            </div>
          </div>
        </CollapsibleContent>
      </Collapsible>

      <Collapsible open={!!(selectedFile || openCreate)}>
        <CollapsibleContent>
          <div
            className="flex flex-col justify-between rounded-lg border border-color-border-secondary bg-color-bg-surface m-1"
            style={{ width: "60rem", height: "39rem" }}
          >
            <div
              className="flex justify-end items-center border-b border-color-border-secondary bg-color-bg-secondary"
              style={{ height: "2.5rem" }}
            />

            <div className="flex justify-center">
              <div
                className="rounded-lg border border-color-border-secondary bg-color-bg-secondary my-2 p-1 flex justify-center"
                style={{ width: "55rem", height: "30rem", overflow: "auto" }}
              >
                <CodeEditor
                  language="json"
                  value={selectedFile ? fileContent : jsonInput}
                  onChange={onCodeChange}
                  selectedTheme="vs-dark"
                  readOnly="false"
                />
              </div>
            </div>

            <div className="flex justify-end items-center bg-color-bg-secondary" style={{ height: "2.5rem" }}>
              <Button variant="text" className="px-3" onClick={onCreateSecret}>Create</Button>
              <Button variant="outlined" className="px-3 ml-2 mr-5" onClick={onCancel}>Cancel</Button>
            </div>
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
});

SecretEditor.displayName = 'SecretEditor';
export default SecretEditor;
